import * as R from 'ramda';
import { useMemo } from 'react';
import type { Control } from 'react-hook-form';
import { useWatch } from 'react-hook-form';

import type { LimitType } from '../components/types';

export const useTypesLimitsFormValues = (control: Control) => {
    const typesLimitedCostField2: LimitType[] = useWatch({ control, name: `limitedCosts.typesLimitedCost_${-2}` });
    const typesLimitedCostField3: LimitType[] = useWatch({ control, name: `limitedCosts.typesLimitedCost_${-3}` });
    const typesLimitedCostField4: LimitType[] = useWatch({ control, name: `limitedCosts.typesLimitedCost_${-4}` });
    const typesLimitedCostField5: LimitType[] = useWatch({ control, name: `limitedCosts.typesLimitedCost_${-5}` });
    const typesLimitedCostField6: LimitType[] = useWatch({ control, name: `limitedCosts.typesLimitedCost_${-6}` });
    const typesLimitedCostField7: LimitType[] = useWatch({ control, name: `limitedCosts.typesLimitedCost_${-7}` });
    const typesLimitedCostField8: LimitType[] = useWatch({ control, name: `limitedCosts.typesLimitedCost_${-8}` });
    const typesLimitedCostField9: LimitType[] = useWatch({ control, name: `limitedCosts.typesLimitedCost_${-9}` });

    const typesLimitsObj: Record<number, LimitType[]> = useMemo(
        () =>
            R.pickBy(R.identity, {
                '-2': typesLimitedCostField2,
                '-3': typesLimitedCostField3,
                '-4': typesLimitedCostField4,
                '-5': typesLimitedCostField5,
                '-6': typesLimitedCostField6,
                '-7': typesLimitedCostField7,
                '-8': typesLimitedCostField8,
                '-9': typesLimitedCostField9,
            }),
        [
            typesLimitedCostField2,
            typesLimitedCostField3,
            typesLimitedCostField4,
            typesLimitedCostField5,
            typesLimitedCostField6,
            typesLimitedCostField7,
            typesLimitedCostField8,
            typesLimitedCostField9,
        ],
    );

    return typesLimitsObj;
};
